import { Radio, type RadioChangeEvent } from 'antd';

import { Flex } from '@/components/base';
import Typo from '@/components/Typography/Typo';
import { CHART_METRIC_VIEW_TYPE } from '@/entities/chart/model/constants';

type Props = {
  value?: CHART_METRIC_VIEW_TYPE;
  onChange: (e: RadioChangeEvent) => void;
};

export const ViewTypeSelect = (props: Props) => {
  return (
    <Flex j="space-between" a="center">
      <Typo type="label2" className="text-gray-600">
        Unit
      </Typo>
      <Radio.Group
        value={props.value}
        onChange={(e) => props.onChange(e)}
        size="small"
      >
        <Radio.Button value={CHART_METRIC_VIEW_TYPE.COUNT}>
          <Typo type="label3" className="px-1">
            #
          </Typo>
        </Radio.Button>
        <Radio.Button value={CHART_METRIC_VIEW_TYPE.PERCENTAGE}>
          <Typo type="label3" className="px-1">
            %
          </Typo>
        </Radio.Button>
      </Radio.Group>
    </Flex>
  );
};
